<template>
  <v-container>
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-layout>
        <jti-expansion-panel panelName="Employee Details">
          <v-container grid-list-lg class="my-0 py-0">
            <v-layout wrap>
              <v-flex md4 class="py-0">
                <v-text-field
                  v-model="data.first_name"
                  label="First Name"
                  :readonly="readonly"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.middle_name" label="Middle Name" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field
                  v-model="data.last_name"
                  label="Last Name"
                  :readonly="readonly"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field
                  v-model="data.email"
                  label="E-mail"
                  :readonly="readonly"
                  :rules="[rules.email]"
                ></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-select
                  v-model="data.gender"
                  label="Gender"
                  :readonly="readonly"
                  :items="genders"
                ></v-select>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.nationality" label="Nationality" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  lazy
                  :disabled="readonly"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="data.birth_date"
                    label="Birthday date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="data.birth_date"
                    :readonly="readonly"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @change="save"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-select
                  v-model="data.civil_status"
                  label="Civil Status"
                  :readonly="readonly"
                  :items="civil_status"
                ></v-select>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.unit_no" label="Unit No." :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.house_no" label="House No." :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.street" label="Street" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.subdivision" label="Subdivision" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.barangay" label="Barangay" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.city" label="City" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.province" label="Province" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field v-model="data.zip_code" label="Zip Code" :readonly="readonly"></v-text-field>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-select
                  v-model="data.employment_status"
                  label="Employee Status"
                  :readonly="readonly"
                  required
                  :items="employee_status_list"
                ></v-select>
              </v-flex>
              <v-flex md4 class="py-0">
                <v-text-field
                  v-model="data.issued_company_id"
                  label="Issued Company ID"
                  :readonly="readonly"
                  required
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="subcompanies" md4 class="py-0">
                <v-select
                  v-model="data.employed_sub_company_id"
                  label="Sub-Company Employed to"
                  :readonly="readonly"
                  required
                  :items="subcompanies"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </jti-expansion-panel>
      </v-layout>
      <v-layout class="mt-3" v-if="!hideAccess">
        <v-flex md5>
          <jti-expansion-panel panelName="Employee Access">
            <v-container grid-list-lg class="my-0 py-0">
              <v-layout justify-center>
                <v-switch
                  :readonly="readonly"
                  v-model="enableAccessCard"
                  color="primary"
                  label="Card Access"
                ></v-switch>
                <!-- <v-checkbox
                  color="primary"
                  v-model="enableAccessCard"
                  hide-details
                  :readonly="readonly"
                  class="shrink mr-2"
                ></v-checkbox>-->
                <v-switch
                  v-model="enableUserAccess"
                  :readonly="readonly || data.user_access===201"
                  color="primary"
                  label="User Access"
                ></v-switch>
              </v-layout>
            </v-container>
          </jti-expansion-panel>
        </v-flex>
        <v-flex md7>
          <v-layout>
            <jti-expansion-panel v-if="showAccessCardSelect" panelName="Access Card Selection">
              <v-container grid-list-lg class="my-0 py-0">
                <v-autocomplete
                  v-model="accessCard"
                  label="Access Card"
                  :readonly="readonly"
                  :items="accessCards"
                  required
                  :rules="[rules.required]"
                ></v-autocomplete>
                <v-select
                  v-if="showPosition"
                  v-model="data.position"
                  label="Position"
                  :clearable="!readonlyProject"
                  :readonly="readonlyProject"
                  required
                  :items="positions"
                ></v-select>
              </v-container>
            </jti-expansion-panel>
          </v-layout>
          <v-layout>
            <jti-expansion-panel v-if="showUserAccessSelect" panelName="User Details">
              <v-container grid-list-lg class="my-0 py-0">
                <v-layout v-if="!hideUserAccess">
                  <v-flex>
                    <v-text-field
                      v-model="userData.username"
                      label="Username"
                      :readonly="readonly"
                      required
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex v-if="!hidePassword">
                    <v-text-field
                      v-model="userData.password"
                      label="Password"
                      type="password"
                      :readonly="readonly"
                      required
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-flex v-if="showRole">
                  <v-select
                    v-model="data.role_id"
                    label="Role"
                    :readonly="readonlyProject"
                    required
                    :items="roles"
                    :clearable="!readonlyProject"
                  ></v-select>
                </v-flex>
                <v-flex v-if="showCompanyRole">
                  <v-select
                    v-model="data.company_role_id"
                    label="Company Role"
                    :readonly="readonlyProject"
                    required
                    :items="companyRoles"
                    :clearable="!readonlyProject"
                  ></v-select>
                </v-flex>
                <v-flex v-if="showSubCompanyRole">
                  <v-select
                    v-model="data.sub_company_role_id"
                    label="Sub Company Role"
                    :readonly="readonlyProject"
                    required
                    :items="subCompanyRoles"
                    :clearable="!readonlyProject"
                  ></v-select>
                </v-flex>
              </v-container>
            </jti-expansion-panel>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
    userData: Object,
    accessCards: Array,
    positions: Array,
    roles: Array,
    companyRoles: Array,
    subCompanyRoles: Array,
    readonly: Boolean,
    readonlyProject: Boolean,
    subcompanies: Array,
    hidePassword: Boolean,
    access_list: Array,
    showRole: Boolean,
    hideUserAccess: Boolean,
    hideAccess: Boolean,
    showPosition: Boolean,
    showRole: Boolean,
    showCompanyRole: Boolean,
    showSubCompanyRole: Boolean
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        first_name: this.data.first_name,
        middle_name: this.data.middle_name,
        last_name: this.data.last_name,
        email: this.data.email,
        gender: this.data.gender,
        nationality: this.data.nationality,
        birth_date: this.data.birth_date,
        civil_status: this.data.civil_status,
        unit_no: this.data.unit_no,
        house_no: this.data.house_no,
        street: this.data.street,
        subdivision: this.data.subdivision,
        barangay: this.data.barangay,
        city: this.data.city,
        province: this.data.province,
        zip_code: this.data.zip_code,
        issued_company_id: this.data.issued_company_id,
        employment_status: this.data.employment_status,
        access_card_id: this.accessCard,
        employed_sub_company_id: this.data.employed_sub_company_id,
        username: this.userData.username,
        password: this.userData.password,
        user_access: this.data.user_access,
        hasAccess: this.showUserAccessSelect,
        position: this.data.position,
        role_id: this.data.role_id,
        company_role_id: this.data.company_role_id,
        sub_company_role_id: this.data.sub_company_role_id
      };
    },
    enableAccessCard: {
      get() {
        return this.data.access_card_id;
      },
      set(val) {
        if (val === false) {
          this.accessCard = null;
        }
        this.showAccessCardSelect = val;
      }
    },
    enableUserAccess: {
      get() {
        let enable = false;

        enable = this.data.user_id
          ? this.userData.status == 1
            ? true
            : false
          : false;
        return enable;
      },
      set(val) {
        this.showUserAccessSelect = val;
      }
    }
  },
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || "This field is required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || !value || "Invalid e-mail.";
        }
      },
      menu: false,
      civil_status: [
        { text: "Single", value: "single" },
        { text: "Widowed", value: "widowed" },
        { text: "Married", value: "married" },
        { text: "Divorced", value: "divorced" }
      ],
      genders: [
        { text: "Male", value: "male" },
        { text: "Female", value: "female" }
      ],
      employee_status_list: [
        { text: "Regular", value: 0 },
        { text: "Contractual", value: 1 },
        { text: "Eskirol", value: 2 }
      ],
      accessCard: this.data.access_card_id,
      showAccessCardSelect: this.data.access_card_id ? true : false,
      showUserAccessSelect: this.data.user_id
        ? this.userData.status === 1
          ? true
          : false
        : false
    };
  },
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    },
    save(date) {
      this.$refs.menu.save(date);
    }
  }
};
</script>

<style>
</style>
